import { SalesOrders_SalesOrderMasterTourSteps } from "../../components/TourGuide/tourGuideData";
import { useEffect, useRef, useState } from "react";
import { HiOutlinePlus } from "react-icons/hi";
import { LiaSearchSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import { salesOrderMaster } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import ConfirmDeleteModal from "../../common/DeleteModel";
import SalesOrderForm from "./SalesOrderForm";
import { RegistryHeader, Button, CalculationFooter } from "../../common/Shared";
import { formatDate } from "../../utlis/formateDate";
import ErrorModal from "../../common/CustomModel";
import { STATUS_COLORS } from "../../utlis/constant";
import { TourGuide } from "../../components/TourGuide/TourGuide";
import { Info } from "lucide-react";

const SalesOrderMaster = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [selectedOrderData, setSelectedOrderData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [formData, setFormData] = useState({
    order_No: 0,
    cust_Id: "",
    order_Date: "",
    delivery_Days: "",
    order_Status_Id: "",
    total_Weight: "",
    total_Qty: "",
    aolly_Id: "",
    calculate_dispatch_date: "",
    packing_Instructions: "",
    general_Notes: "",
    nalco_Rate: "",
    nalco_Addition: "",
    final_Rate: "",
    created_By: userId,
    OrderDetails: [
      {
        dieId: "",
        powder_Coating_Color: "",
        Profile_Length: "",
        qty: "",
        qty_Weight: "",
        created_By: userId,
        unit_Conv_Id: "",
      },
    ],
  });
  const pageSize = 50;
  const tableScrollRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const isFetchingRef = useRef(false);
  const [isTourOpen, setIsTourOpen] = useState(false);

  const handleTourComplete = () => {
    localStorage.setItem("aluex_so_tour_seen", "true");
  };

  const fetchSaleOrderData = async () => {
    setLoading(true);

    try {
      const res = await salesOrderMaster.getAllOrders(currentPage, pageSize);
      if (currentPage === 1) {
        setOrderData(res.data || []);
      } else {
        setOrderData((prev) => [...prev, ...(res.data || [])]);
      }

      if (!res.data || res.data.length < pageSize) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }

      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching die master data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || !hasMore || isFetchingRef.current) return;
      const { scrollTop, clientHeight, scrollHeight } = el;
      if (scrollHeight - scrollTop <= clientHeight + 120) {
        isFetchingRef.current = true;
        setCurrentPage((p) => p + 1);
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    fetchSaleOrderData();
  }, [currentPage]);

  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(orderData);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = orderData.filter((d) => {
        return (
          d.customerName?.toLowerCase().includes(query) ||
          d.order_No?.toString().includes(query) ||
          d.aolly_Name?.toLowerCase().includes(query) ||
          d.status_Name?.toLowerCase().includes(query)
        );
      });
      setFilteredData(filtered);
    }
  }, [searchQuery, orderData]);

  const handleAdd = () => {
    setIsEditing(false);
    setSelectedOrderData(null);
    setIsModelOpen(true);
  };

  const handleEdit = async (id) => {
    setLoading(true);
    try {
      const response = await salesOrderMaster.getById(id);
      if (response.data) {
        const fetchedData = response.data;
        const formattedInitialData = {
          ...fetchedData,
          order_No: fetchedData.order_No,
          order_Date: fetchedData.order_Date?.split("T")[0],
          calculate_dispatch_date:
            fetchedData.calculate_dispatch_date?.split("T")[0],
          delivery_Days: fetchedData.delivery_Days?.toString() || "",
          OrderDetails: fetchedData.orderDetails.map((item) => ({
            order_Detail_Id: item.order_Detail_Id,
            dieId: item.id,
            profileLengthFt: item.profile_Length,
            quantityPcs: item.qty,
            qtyWeight: item.qty_Weight,
            coatingColor: item.powder_Coating_Color,
            unit_Conv_Id: item.unit_Conv_Id,
            currentWeight: item.currentWeight,
          })),
        };

        setSelectedOrderData(formattedInitialData);
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (error) {
      notify("Failed to fetch sales order master details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      await salesOrderMaster.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchSaleOrderData();
    } catch (error) {
      notify("Failed to delete record", "error");
    } finally {
      setLoading(false);
      setIsDeleteModalOpen(false);
      setSelectedId(null);
    }
  };

  const handleSave = async (salesOrderData, id) => {
    setIsSaving(true);
    try {
      await salesOrderMaster.saveOrUpdate(salesOrderData);
      notify(id ? "Updated successfully" : "Added successfully", "success");
      fetchSaleOrderData();
      setIsModelOpen(false);
      setFormData("");
      setIsEditing(false);
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const totalQty = orderData.reduce(
    (sum, x) => sum + Number(x.total_Qty || 0),
    0,
  );
  const totalWeight = orderData.reduce(
    (sum, x) => sum + Number(x.totalEst || 0),
    0,
  );

  if (isModelOpen) {
    return (
      <SalesOrderForm
        initialData={selectedOrderData}
        key={JSON.stringify(selectedOrderData)}
        onSave={handleSave}
        onCancel={() => {
          setIsModelOpen(false);
          setSelectedOrderData(null);
        }}
        isEditing={isEditing}
        isSaving={isSaving}
      />
    );
  }

  return (
    <div className="flex flex-col h-full bg-white font-plus relative">
      {isSaving && <Loader centered />}
      {loading && <Loader centered />}
      <RegistryHeader title="Sales Order">
        <div className="relative w-full sm:w-80 group">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none group-focus-within:text-primary">
            <LiaSearchSolid size={18} className="text-gray-400 transition-colors" />
          </div>
          <input
            type="text"
            placeholder="Search by CUSTOMER / ORDER NO..."
            className="block w-full pl-12 pr-10 py-2 bg-gray-50 border border-gray-200 text-gray-900 text-[11px] font-black uppercase tracking-[2px] focus:border-primary focus:bg-white focus:outline-none transition-all placeholder:text-gray-300"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-red-500 transition-colors"
            >
              <MdClose size={18} />
            </button>
          )}
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => setIsTourOpen(true)}
            className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
            title="Page Guide"
          >
            <Info size={14} />
            Guide
          </button>
        </div>
        <div data-tour="so-add">
          <Button onClick={handleAdd} icon={HiOutlinePlus}>
            Add Order
          </Button>
        </div>
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col" data-tour="so-table">
        <div
          ref={tableScrollRef}
          className="relative overflow-auto border border-gray-200 bg-white flex-1"
        >
          <div className="min-w-max">
            <Table
              columns={[
                {
                  key: "order_Date",
                  label: "ORDER DATE",
                  align: "center",
                  render: (value) => formatDate(value),
                },
                { key: "order_No", label: "ORDER NO", align: "center", },
                { key: "customerName", label: "CUSTOMER", align: "center", },
                { key: "aolly_Name", label: "ALLOY", align: "center", },
                { key: "itemCount", label: "ITEMS", align: "center" },
                { key: "total_Qty", label: "PCS", align: "center" },
                { key: "totalEst", label: "WEIGHT", align: "center" },
                {
                  key: "status_Name", label: "STATUS", align: "center", render: (val) => {
                    const color = STATUS_COLORS[val] || "bg-slate-100 text-slate-600";
                    return (
                      <span
                        className={`px-3 py-1 border rounded-none text-[9px] font-black uppercase tracking-[2px] ${color}`}
                      >
                        {val || '-'}
                      </span>
                    );
                  },
                },
                {
                  key: "calculate_dispatch_date",
                  label: "DISPATCH",
                  align: "center",
                  render: (value) => formatDate(value),
                },
                { key: "delivery_Days", label: "LEAD TIME", align: "center" },
              ]}
              data={filteredData}
              onEdit={(row) => handleEdit(row.order_No)}
              onDelete={(row) => handleDelete(row.order_No)}
              tableClassName="text-[12px] font-bold"
            />
          </div>
        </div>
      </div>

      <div data-tour="so-footer">
        <CalculationFooter
          items={[
            {
              label: "Cumulative Pieces",
              value: totalQty.toLocaleString(),
              suffix: "PCS"
            },
            {
              label: "Cumulative Weight",
              value: totalWeight.toFixed(3),
              suffix: "KG",
              color: "text-primary"
            }
          ]}
        />

        <ConfirmDeleteModal
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onConfirm={handleConfirmDelete}
        />

        {errorModalOpen && (
          <ErrorModal
            message={errorMessage}
            subMessage={errorSubMessage}
            onClose={() => setErrorModalOpen(false)}
          />
        )}

        <TourGuide
          isOpen={isTourOpen}
          onClose={() => setIsTourOpen(false)}
          steps={SalesOrders_SalesOrderMasterTourSteps}
          onComplete={handleTourComplete}
        />
      </div>
    </div>
  );
};

export default SalesOrderMaster;
